@let threadFindings = threadFindingsModel();
@if (!threadFindings) {
  <div class="thread-findings__loader-container">
    <mat-progress-spinner color="primary" mode="indeterminate" />
  </div>
} @else {
  @if (withSensitiveData()) {
    <app-fetch-all-content-bar [integrationId]="selectedIntegration!.id" [threadId]="findingThreadId()" />
  }

  <section class="thread-findings">
    <div class="thread-findings-header">
      <div class="thread-findings-header-title">
        <img class="icon" [src]="aiServiceIconPath()" />
        <span appLongTextTooltip>{{ threadFindings.name }}</span>
        <app-copy-button [value]="threadFindings.id" />
      </div>
      <div class="thread-findings-header-info">
        <div class="thread-findings-header-info-title">Findings</div>
        <app-severities-cell [severities]="threadFindings.findingsBySeverity" />
        <div class="thread-findings-header-info-title">Client Application</div>
        <div class="client-application-container">
          <img [src]="threadFindings.clientApplication | clientApplicationIcon" />
          <span>{{ threadFindings.clientApplication | displayCamelCaseString }}</span>
        </div>
        <div class="thread-findings-header-info-title">Agent</div>
        @if (shouldShowAgentLink()) {
          <div class="agent-link" (click)="navigateToAgent()">
            {{ threadFindings.agentName }}
          </div>
        } @else {
          <div>{{ threadFindings.agentName }}</div>
        }
        <div class="thread-findings-header-info-title">Actors</div>
        <div>
          @if (
            threadFindings.actorNames && threadFindings.actorNames.length && threadFindings.actorNames[0] === 'N/A'
          ) {
            <span>N/A</span>
          } @else if (threadFindings.actorNames && threadFindings.actorNames.length) {
            <div class="actors-display">
              @if (threadFindings.actorNames.length === 1) {
                <p-avatar
                  [label]="threadFindings.actorNames[0][0] | uppercase"
                  shape="circle"
                  [style]="threadFindings.actorNames[0] | avatarStyle"
                />
              } @else {
                <p-avatarGroup>
                  @for (actor of threadFindings.actorNames; track actor) {
                    <p-avatar
                      [label]="(actor && actor.length ? actor[0] : '?') | uppercase"
                      shape="circle"
                      [style]="actor | avatarStyle"
                    />
                  }
                </p-avatarGroup>
              }
              <span class="actors-text">
                @for (actor of threadFindings.actorNames; track actor; let idx = $index) {
                  @if (shouldShowActorLink(threadFindings.actorInventoryIds[idx])) {
                    <span class="actor-link" (click)="navigateToActor(threadFindings.actorInventoryIds[idx])">{{
                      actor
                    }}</span>
                  } @else {
                    <span>{{ actor }}</span>
                  }
                  @if (idx < threadFindings.actorNames.length - 1) {
                    <span>, </span>
                  }
                }
              </span>
            </div>
          }
        </div>
        <div class="thread-findings-header-info-title">First activity</div>
        <div>{{ threadFindings.firstActivity | date: 'MMM d, y, HH:mm' }}</div>
        <div class="thread-findings-header-info-title">Last activity</div>
        <div>{{ threadFindings.lastActivity | date: 'MMM d, y, HH:mm' }}</div>
      </div>
    </div>

    <div class="thread-findings-body">
      <div class="thread-findings-body-title">
        <span>{{ visibleFindings().length }} {{ visibleFindings().length > 1 ? 'Findings' : 'Finding' }}</span>
        @if (activeStepId()) {
          <div class="thread-findings-active-step-filter" [matTooltip]="activeStepId()">
            <div class="text">Step ID: {{ activeStepId() }}</div>
            <img
              src="assets/images/common/cancel-hollow.svg"
              (click)="$event.stopPropagation(); activeStepId.set('')"
              alt="cancel"
            />
          </div>
        }
      </div>

      <div class="thread-findings-body-list">
        @for (finding of visibleFindings(); track finding.id) {
          <app-expandable-item>
            <div expandable-item-title class="thread-findings-item-header-container">
              <app-severities-cell [severities]="finding.severity" [showSeverityCount]="false" />
              <span
                class="thread-findings-item-header"
                [matTooltip]="finding.rule.displayName"
                matToolpitShowDelay="300"
                >{{ finding.rule.displayName }}</span
              >
            </div>
            <app-finding-item [finding]="finding" (evidenceStepClicked)="scrollToRelatedStep(finding, $event)" />
          </app-expandable-item>
        }
      </div>
    </div>
  </section>
  <section class="thread-findings__steps-messages">
    @if (threadFindings.activities) {
      <app-activities-messages
        [activities]="threadFindings.activities"
        [findingsByActivity]="threadFindings.findingsByActivity"
        [findingIdsByActivity]="threadFindings.findingIdsByActivity"
        [showDeleteAction]="isDeleteThreadAvailable()"
        (findingsForActivityClicked)="activeStepId.set($event)"
        (deleteThreadClicked)="deleteThread()"
      />
    }
  </section>
}
